export default "__VITE_ASSET__a2cb6256__"